import React from 'react';
import Paragraph from '../components/Paragraph/Paragraph';
import Slideshow from '../components/Slideshow/Slideshow';
import ContextImage from '../components/ContextImage/ContextImage';
import Image from '../components/Image/Image';
import Quote from '../components/Quote/Quote';
import Intro from '../components/Intro/Intro';
import Header from '../components/Header/Header';

const Modular = ({ modules }) => (
  <>
    {modules &&
      modules.map((module, i) => {
        switch (module.__typename) {
          case 'WordPressAcf_header':
            return (
              <Header
                key={module.id}
                variant={module.style}
                rubrieken={module.rubrieken}
                quote={module.quote}
                title={module.title}
                meta={module.meta}
                bg={module.bg}
                backdrop={module.bg_backdrop}
              />
            );

          case 'WordPressAcf_intro':
            return <Intro key={i} text={module.text} variant={module.style} />;

          case 'WordPressAcf_paragraph':
            return (
              <Paragraph
                key={i}
                background={module?.background}
                text={module.text}
              />
            );

          case 'WordPressAcf_slideshow':
            return (
              <Slideshow
                key={i}
                title={module.title}
                images={module.afbeeldingen}
              />
            );

          case 'WordPressAcf_context_image':
            return (
              <ContextImage
                key={i}
                context={module.context}
                image={module.image}
              />
            );

          case 'WordPressAcf_image':
            return (
              <Image key={module.id} image={module.image} size={module.size} />
            );

          case 'WordPressAcf_quote':
            return <Quote key={module.id} text={module.text} />;

          default:
            console.error(`Module not found: ${module.__typename}`);
        }
      })}
  </>
);

export default Modular;
